export default __webpack_public_path__ + "static/blob9-1c8e0ca386183df2769dc60399633059.svg";